<template>
  <b-container class="my-8">
    <modal-loading
      :openModal="true"
      :value="0"
      :class="'full-modal'"
      style="width: 10em"
      :background_img="`img/janoo-icon-high-color.png`"
      :label="'... '"
    >
    </modal-loading>
  </b-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'

export default {
  data() {
    return {}
  },

  components: {
    ModalLoading,
  },

  computed: {
    ...mapGetters('auth', {
      params: 'params',
      user: 'user',
    }),
  },

  methods: {
    ...mapActions('auth', ['logoutRequest', 'fetchUserDetails']),

    ...mapActions('report', ['reportStoreCommit']),

    ...mapActions('product', ['resetChartsCache']),
  },

  async mounted() {
    this.reportStoreCommit({ mutation: 'RESET_SHOW_SPLASH' })

    try {
      if (this.user && this.user.uuid) {
        await this.fetchUserDetails(this.user.uuid)
      }

      // TODO: use store.state from @/store instead...
      let homepage = this.params.User.indexpage || ''

      let resolved = this.$router.resolve(homepage)
      if (resolved.route.name != '404' && resolved.route.name != 'userLogin') {
        this.$router.push(decodeURIComponent(resolved.href).replace(/@/g, '=')) // comment to teste
      } else {
        this.$router.push('/dashboard') // comment to teste
      }
    } catch (error) {
      await this.resetChartsCache()
      this.logoutRequest().then(() => {
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push('/login') // comment to teste
      })
    }
  },
}
</script>

<style lang="css">
.full-modal .modal-dialog {
  transition: none;
}

.full-modal .modal-body {
  padding: 0 1.5rem;
}

.full-modal .fade,
.full-modal .modal.fade .modal-dialog,
.full-modal .modal-content {
  transition: none;
  -webkit-transition: none;
}

.full-modal .progress .progress-bar {
  color: transparent;
}

.full-modal,
.full-modal .modal-content {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
  background-color: #f5f9f9;
}
</style>
